<template>
  <div class="lecto-params">
    <div class="name">{{productDetail.ProdName}}</div>
    <div v-if="getStandardData.standard_name" class="standard-name">标准名称：{{getStandardData.standard_name}}</div>
    <div class="lecto-title">产品选型</div>
    <ul class="params-ul" :class="`${templateKey}-params-ul`">
      <li class="params-li li-header">
        <div class="params-name">属性名称</div>
        <div class="params-val">属性值</div>
        <div class="params-desc">备注</div>
      </li>
      <li class="params-li" v-for="(item, index) in lectoParams.LectotypeParams" :key="`lecto_${index}`" :data-name="item.Name" :data-index="index">
        <div class="params-name"><span class="text-clamp2" :title="item.Name">{{item.Name}}</span></div>
        <div class="params-val">
          <!-- 仅显示 -->
          <span v-if="item.ParamType === 0">{{item.Value}}</span>
          <!-- 下拉筛选 -->
          <el-select
            v-if="item.ParamType === 3"
            clearable
            v-model="item.Value"
            :placeholder="`请选择${item.Name}`"
            @change="paramsChange(item, index)"
            size="small"
          >
            <el-option
              v-for="(v, index) in item.Values"
              :key="v + index"
              :label="v"
              :value="v"
            >
            </el-option>
          </el-select>
          <!-- input输入值 -->
          <el-input size="small" v-if="item.ParamType === 1" v-model="item.Value" :placeholder="item.Hint || `请输入${item.Name}`" @blur="paramsChange(item, index)" />
        </div>
        <div class="params-desc">{{item.Remark || ''}}</div>
      </li>
    </ul>

    <div class="select-sku">
      <div class="sku-name" v-if="lectoParams.LectotypeParams.length <= 0">未设置规格参数</div>
      <div class="sku-name" v-else>选型：{{lectoParams.IsSelected ? lectoParams.SkuName : '未确定型号'}}</div>
      <div class="sku-name-edit">
        <span @click="copy"><i class="el-icon el-icon-document-copy"></i>复制</span>
        <span @click="clearParams"><i class="el-icon el-icon-delete"></i>清除</span>
        <span v-if="isSkuFavorite" style="color: #606266">已加入常用零配件</span>
        <span
          @click="saveParams"
          v-else
        ><i class="el-icon el-icon-folder-add"></i>加入我的常用零配件</span>

        <el-checkbox
          v-if="isClient && productDetail.HasModel != 0"
          :title="!lectoParams.SkuName ? '请先完成产品选型' : ''"
          :disabled="!lectoParams.SkuName || isHasDoc"
          v-model="IsAddToCurrentAssembly"
        >将模型插入当前装配体</el-checkbox>
      </div>
    </div>

    <!-- 无模型的产品展示价格 -->
    <lectoParamsPrice
      v-if="productDetail.HasModel == 0"
      :lectoParams="lectoParams"
      :productDetail="productDetail"
    >
    </lectoParamsPrice>
    <!-- 正常大工程师模型下载逻辑 -->
    <lectoParamsDown
      :lectoParams="lectoParams"
      :lectoProId="lectoProId"
      :productDetail="productDetail"
      :IsAddToCurrentAssembly="IsAddToCurrentAssembly"
      v-else-if="downType === 'client'"
    ></lectoParamsDown>
    <!-- PC端浏览器模型下载逻辑 -->
    <lectoParamsDownPc
      :lectoParams="lectoParams"
      :lectoProId="lectoProId"
      :productDetail="productDetail"
      :checkParams="checkParams"
      v-else-if="downType === 'web'"
    ></lectoParamsDownPc>
    <lectoParamsDownTianzhun
      :lectoParams="lectoParams"
      :lectoProId="lectoProId"
      :productDetail="productDetail"
      :checkParams="checkParams"
      @noticeParentMessage="(key) => $emit('noticeParentMessage', key)"
      v-else-if="downType == 'tianzhunIframe'"
    ></lectoParamsDownTianzhun>
    <!-- 非客户端、非浏览器暂时不支持下载 -->
    <lectoParamsDownDis v-else></lectoParamsDownDis>

    <dir-selector
      ref="dirSelector"
      categoryType="LectoFavoriteDir"
      @ensure="_lectoFavorite"
    ></dir-selector>

  </div>
</template>

<script>
import { Message as ElMessage } from 'element-ui'
import {WinForm, AppName, CheckLibs, DscStorageLib} from '@digital-supply-chain/module'
import useClipboard from 'vue-clipboard3'
import {CommonService} from '@/service'
import {Category,IframePostMessage} from '@/libs'

import {getLectoFavoriteParams} from './lectoParamsDown'

import DirSelector from '@/components/dir-selector/index.vue'
import LectoParamsDown from './lectoParamsDown.vue';
import lectoParamsDownDis from './lectoParamsDownDis.vue';
import lectoParamsDownPc from './lectoParamsDownPc.vue';
import lectoParamsDownTianzhun from './lectoParamsDownTianzhun.vue';
import lectoParamsPrice from './lectoParamsPrice.vue';

export default {
  props: {
    lectoParams: { default: { LectotypeParams: [] } },
    lectoProId: { default: 0 },
    productDetail: { default: {} },
    checkParams: { default: {} },
    templateKey: { default: '' },
    isSkuFavorite: { default: false },
  },
  inject: ['productDocs', 'standardData'],
  components: { LectoParamsDown, DirSelector, lectoParamsDownDis, lectoParamsDownPc, lectoParamsDownTianzhun, lectoParamsPrice },
  data() {
    return {
      IsAddToCurrentAssembly: false,
      isClient: CheckLibs.isClient(),

      isTianzhunIframe: DscStorageLib.sessionGet(IframePostMessage.NeIframeAgent).name == IframePostMessage.NeIframeAgentTianZhun,
    }
  },
  computed: {
    /**选型下载方式 */
    downType() {
      let type = 'web';
      if (window.md) {
        type = 'client';
        switch(WinForm.md.getAppName()) {
          case AppName.KYBao:
            type = 'disabled';
          break;
          case AppName.GreatIM:
            type = 'disabled';
          break;
        }
      } else if (this.isTianzhunIframe) {
        type = 'tianzhunIframe'
      } else {
        type = 'web';
      }
      return type;
    },
    getStandardData() {
      return this.standardData();
    },
    // 当前选型参数下是否存在图纸
    isHasDoc() {
      let findOne = null;
      this.productDocs.forEach(docs => {
        if(this.lectoParams.SkuName && docs.FileName.toLowerCase()  == this.lectoParams.SkuName.toLowerCase() ) {
          findOne = docs;
        }
      });
      return findOne ? true : false;
    },
  },
  methods: {
    paramsChange(item, index) {
      if (!this.lectoParams.SkuName) {
        this.autoMoveScroll();
      }
      this.$emit('_checkParamsChange', item.Name, item.ID, item.Value, item.Remark)
    },
    autoMoveScroll() {
      const allParamsLi = document.querySelectorAll('.top-params-ul .params-li');
      let noChooseDom = null;
      for (var i=0;i<allParamsLi.length;i++){
        if (!allParamsLi[i].dataset.name) {
          continue;
        }
        const item = this.lectoParams.LectotypeParams.find(item => item.Name === allParamsLi[i].dataset.name);
        if (!item.Value) {
          noChooseDom = allParamsLi[i];
          break;
        }
      }
      if (!noChooseDom) return;
      setTimeout(() => {
        document.querySelector('.product-detail .params-ul').scrollTop = (36 * Number(noChooseDom.dataset.index)) - 72;
      }, 100)
    },
    clearParams() {
      this.$emit('_clearCheckParams');
      document.querySelector('.product-detail .params-ul').scrollTop = 0;
    },
    saveParams() {
      if (!this.lectoParams.SkuName) {
        ElMessage('请先完成选型')
        return false;
      }
      this.$refs.dirSelector.show();
    },

    async _lectoFavorite(currentNode) {
      const {ProdID} = this.productDetail;
      const paramsData = getLectoFavoriteParams(this.productDetail, this.lectoParams, this.checkParams);
      const res = await CommonService.add(currentNode.CategoryID, Category.Outsourcing, currentNode.DirID, {
        ProdID,
        Params: paramsData.data,
        Md5: paramsData.md5
      });
      if (res) {
        ElMessage({
          message: '添加成功',
          type: 'success',
        })
        this.$parent.existSkuFavorite();
      }
    },

    async copy() {
      if (!this.lectoParams.SkuName) {
        ElMessage('请先完成选型')
        return false;
      }
      const { toClipboard } = useClipboard()
      try {
        await toClipboard(this.lectoParams.SkuName)
        ElMessage({
          message: '复制成功',
          type: 'success',
        })
      } catch (e) {
        ElMessage({
          message: '复制失败',
          type: 'warning',
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.lecto-params{
  width: 560px;
  float: left;
  .standard-name{
    font-size: 14px;
    color: #666666;
    margin-bottom: 6px;
  }
  .name{
    font-size: 20px;
    font-weight: 500;
    padding: 6px 0;
    color: @text-color-base;
  }
}
.lecto-title{
  width: 100%;
  height: 36px;
  background: #F1F1F1;
  color: @text-color-base;
  line-height: 34px;
  padding-left: 12px;
  border: 1px solid @line-strong-color;
}
.params-ul{
  width: 100%;
  background: #FFFFFF;
  border: 1px solid @line-strong-color;
  border-bottom: 0 none;
  position: relative;
  font-size: 14px;
  &.top-params-ul{
    max-height: 260px;
    overflow-y: auto;
    .li-header{
      position: sticky;
      left: 0;
      top: 0;
      z-index: 1;
      &>div{
        background: #FAFAFA;
      }
    }
  }
}
.params-li{
  width: 100%;
  height: 36px;
  background: #ffffff;
  display: flex;
  align-items: center;
  &>div{
    padding: 0 16px;
    height: 36px;
    color: @text-color-base;
    border-right: 1px solid @line-strong-color;
    border-bottom: 1px solid @line-strong-color;
    display: flex;
    align-items: center;
  }
  .params-name{
    width: 30%;
    &>span{
      max-height: 90%;
      width: 100%;
    }
  }
  .params-val{
    width: 45%;
  }
  .params-desc{
    width: 25%;
  }
}
.select-sku{
  height: 60px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-top: 0 none;
  display: flex;
  // align-items: center;
  // justify-content: space-between;
  padding: 0 26px;
  flex-direction: column;
  justify-content: center;
}
.sku-name{
  color: @text-color-base;
  font-size: 18px;
  font-weight: bold;
  // flex: 1;
}
.sku-name-edit{
  color: @a-color-active;
  // width: 150px;
  margin-top: 8px;
  font-size: 15px;
  &>span{
    cursor: pointer;
    margin-right: 22px;
    display: inline-flex;
    align-items: center;
  }
  i{
    margin-right: 6px;
    font-size: 15px;
  }
  /deep/ .el-checkbox{
    font-size: 15px;
  }
}
</style>
